import { createLogger } from "utils/logging";
import { fetchRetry } from "utils/fetch";
import { benefitBounce } from "@otto-ec/nexus-registry/benefit/bounce";
import { defineEvent } from "@otto-ec/global-resources/nexus";
import { captureErrorWithPayload } from "utils/error";
import { BenefitElement, defineElement } from "../BenefitElement";

const attributeNameVariationId = "variation-id";
const attributeNameFeature = "feature";
const attributeNameTeam = "team";

const log = createLogger("tag", "bounce.component");
const BOUNCE_ELEMENT_NAME = "ft9-bounce-v1";

const ERROR_KEY = "ft9-benefit-tag-bounce-not-ok";

if (!benefitBounce.isReady) {
	benefitBounce.assignNamespace({
		init: defineEvent(),
	});
}

export class BounceElement extends BenefitElement {
	protected async onInit(): Promise<void> {
		await this.callBackend();
	}

	protected async callBackend() {
		this.replaceChildren(); /*                       */

		const urlSearchParams = this.createSearchParams();
		log.info("Calling bounce for %s with %s", this.id || "id-not-set", urlSearchParams.toString());

		try {
			const response = await fetchRetry({
				url: `/benefit-tag/bounce?${urlSearchParams}`,
				namespace: "tag",
				fetchOptions: {
					headers: {
						Accept: "text/html;charset=UTF-8",
						"X-Requested-With": "XMLHttpRequest",
						"X-feature": this.getAttribute(attributeNameFeature) ?? "unset",
						"X-team": this.getAttribute(attributeNameTeam) ?? "unset",
					},
					priority: "high",
				},
				retryOptions: {
					limit: 2,
					delay: 50,
				},
			});
			if (!response.ok) {
				log.error("tag endpoint returns a non ok response!", response.status);

				const labels = {
					response_type: response.type,
					tries: 1,
				};

				captureErrorWithPayload("callBackend error", "tag", "bounce", ERROR_KEY, response.status, labels);
				return;
			}
			this.innerHTML = await response.text();
			benefitBounce.init.emit({}, { retain: true });
		} catch (error) {
			log.error("tag bounce request returns an error!", error);

			const labels = {
				url_search_params: urlSearchParams.toString(),
				tries: 3,
			};
			captureErrorWithPayload("callBackend error", "tag", "bounce", ERROR_KEY, error, labels);
		}
	}

	protected createSearchParams() {
		return this.buildSearchParams({
			variationId: this.getAttribute(attributeNameVariationId),
		});
	}
}

defineElement(BounceElement, BOUNCE_ELEMENT_NAME, "ftnine_emergency_custom_element_disable_bounce");
